<template>
    <div class="container mescroll-touch">
        <img src="../../assets/images/regmeetingtop.png" class="img" />
        <!-- <img src="../../assets/images/topguanggao.png" class="guanggaoimg" /> -->
        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/regtitleimg.png" class="modeltitleimg" />
                    <div class="modeltitletext">注册费</div>
                </div>
            </div>

            <table class="maintable" cellspacing="0">
                <tr>
                    <th class="inth"></th>
                    <th class="inth">普通参会</th>
                    <th class="inth">专委会会员</th>
                    <th class="inth">学生代表</th>
                </tr>
                <tr>
                    <td class="intd">4月10日-7月31日</td>
                    <td class="intd center">600元</td>
                    <td class="intd center">200元</td>
                    <td class="intd center">200元</td>
                </tr>
                <tr>
                    <td class="intd">8月1日之后</td>
                    <td class="intd center">800元</td>
                    <td class="intd center">200元</td>
                    <td class="intd center">200元</td>
                </tr>
            </table>
            <div class="ziti">*注册费包含会议资料费用，会议期间午餐由大会统一安排。住宿交通自理</div>
        </div>

        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/regtitleimg.png" class="modeltitleimg" />
                    <div class="modeltitletext">注册费</div>
                </div>
            </div>
            <div class="neirong ziti">本次大会团队注册【10人（含）以上】，请直接联系</div>
            <div class="preple ziti">刘老师：15800797187</div>
        </div>

        <div class="model">
            <img src="../../assets/images/jiaofeiqr.png" class="qrimg" />
        </div>
        <floatback />
    </div>
</template>

<script>
import floatback from './floatback.vue';
import mixin from '../../common/mixin/mixins'
export default {
    name: 'regmeeting',
    data() {
        return {
        }
    },
    mixins: [mixin],
    components: {
        floatback
    },
    created() {
        this.initacmedShare();
        document.title = "ACMED第一届学术年会";
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
.container {
    height: 100%;
    width: 100%;
    // background: rgb(228, 236, 255);
}

.img {
    display: block;
    width: 100%;
    margin-bottom: .2rem
}

.guanggaoimg {
    display: block;
    width: 92%;
    margin: 0.5rem auto;
}

.modelline {
    border-bottom: 1px solid rgb(0, 61, 155);
    border-bottom-left-radius: 50rem;
}

.modeltitle {
    background: rgb(0, 61, 155);
    width: 37%;
    display: flex;
    flex-direction: row;
    padding: 0.1rem;
    border-radius: 30px 50px 0px 30px;
}

.modeltitleimg {
    display: block;
    width: 15%;
    background: #fff;
    border-radius: 50rem;
    width: 0.5rem;
    height: 0.5rem;
    box-sizing: border-box;
    padding: 0.05rem;
}

.modeltitletext {
    margin-left: 0.2rem;
    color: #fff;
    font-weight: bold;
    // font-size: 16px;
}

.model {
    width: 92%;
    margin: auto;
    margin-top: 0.5rem;
}

.maintable {
    width: 100%;
    margin: 0.4rem 0;
    font-size: .37rem;
}

.intd {
    padding: .2rem;
    border: 1px solid rgb(190, 211, 246);
}

.inth {
    padding: .1rem 0;
    background: rgb(0, 54, 134);
    color: #fff;
    border: 1px solid rgb(190, 211, 246);
}

.center {
    text-align: center;
}

.preple {
    color: rgb(0, 54, 134);
}

.neirong {
    margin-top: .3rem
}

.ziti {
    font-size: .37rem;
}

.qrimg {
    display: block;
    margin: auto;
    width: 40%;
    margin-top: 1rem;
}
</style>